import { Form, Field } from 'react-final-form'
import { FormattedMessage } from 'react-intl'
import { FinalFormInput } from '../forms/Input'
import { isValidEmail } from 'utils'
import { createUrl } from '../../localized-urls'
import { FORM_ERROR } from 'final-form'
import createDecorator from 'final-form-focus'
import API from '../../api'
// import { saveToken, setUser } from "./auth";

const focusOnError = createDecorator()

const validate = (values) => {
  const errors = {}

  if(!values.firstName) {
    errors.firstName = (
      <FormattedMessage
        id='required_field'
        defaultMessage='This field is required!'
      />
    )
  }

  if(!values.lastName) {
    errors.lastName = (
      <FormattedMessage
        id='required_field'
        defaultMessage='This field is required!'
      />
    )
  }

  if(!values.email) {
    errors.email = (
      <FormattedMessage
        id='required_field'
        defaultMessage='This field is required!'
      />
    )
  } else if(!isValidEmail(values.email)) {
    errors.email = (
      <FormattedMessage
        id='invalid-email'
        defaultMessage='Invalid email address'
      />
    )
  }

  if(!values.password) {
    errors.password = (
      <FormattedMessage
        id='required_field'
        defaultMessage='This field is required!'
      />
    )
  }

  if(!values.isTermsAccepted) {
    errors.isTermsAccepted = (
      <FormattedMessage
        id='required_field'
        defaultMessage='This field is required!'
      />
    )
  }
  return errors
}

export default function RegistrationForm({ onSubmitSuccess }) {
  const onSubmit = (credentials) => {
    const captcha = window.grecaptcha ? window.grecaptcha.getResponse() : true
    if(captcha) {
      return API('account/register/')
        .post(credentials)
        .then((result) => {
          if(result.user) {
            // saveToken(result.token)
            // setUser(result.user)
            if(typeof onSubmitSuccess === 'function') {
              onSubmitSuccess(result.user)
            } else {
              window.location.href = createUrl('register_completed')
            }
          }
        })
        .catch(({ error }) => {
          return { [FORM_ERROR]: [Object.values(error)] }
        })
    } else {
      return {
        [FORM_ERROR]: [
          <FormattedMessage
            id='captcha-requred'
            defaultMessage='Captcha is required'
          />,
        ],
      }
    }
  }
  return (
    <Form
      onSubmit={onSubmit}
      decorators={[focusOnError]}
      validate={validate}
      subscription={{
        value: true,
        active: true,
        error: true,
        touched: true,
        submitted: true,
        submitError: true,
      }}
    >
      {({ handleSubmit, submitError }) => (
        <form className='form' onSubmit={handleSubmit}>
          <div>
            <Field
              name='firstName'
              component={FinalFormInput}
              icon={
                <img
                  className='icon'
                  src={`${window.staticPath}travel_dist/images/person.svg`}
                />
              }
              label={
                <FormattedMessage id='firstName' defaultMessage='FIRST NAME' />
              }
              // `${window.staticPath}/travel_dist/images}`
            />
          </div>
          <div>
            <Field
              name='lastName'
              component={FinalFormInput}
              icon={
                <img
                  className='icon'
                  src={`${window.staticPath}travel_dist/images/person.svg`}
                />
              }
              label={
                <FormattedMessage id='lastName' defaultMessage='Last name' />
              }
            />
          </div>
          <div>
            <Field
              name='email'
              component={FinalFormInput}
              icon={
                <img
                  className='icon'
                  src={`${window.staticPath}travel_dist/images/mail.svg`}
                />
              }
              label={<FormattedMessage id='email' defaultMessage='Email' />}
            />
          </div>
          <div>
            <Field
              name='password'
              type='password'
              icon={
                <img
                  className='icon'
                  src={`${window.staticPath}travel_dist/images/lock.svg`}
                />
              }
              component={FinalFormInput}
              label={
                <FormattedMessage id='password' defaultMessage='Password' />
              }
            />
          </div>
          {/* <div>
            <Field
              name='isTermsAccepted'
              type='checkbox'
              className='checkbox-wrapper-login'
              component={Checkbox}
              label={
                <FormattedHTMLMessage
                  id='accept_checkbox'
                  values={{
                    target,
                  }}
                  defaultMessage="I accept PADI Travel`s <a href='https://travel.padi.com/terms/' target='{target}'>Terms &amp; Conditions</a>"
                />
              }
            />
          </div> */}
          {/* <div>
            <Field
              name='getmail'
              type='checkbox'
              component={Checkbox}
              className='checkbox-wrapper-login'
              label={
                <FormattedHTMLMessage
                  id='getmail_checkbox'
                  defaultMessage='I want to get PADI Travel`s emails related to the Affiliate Program (e.g. news, invitation to webinars, best practice tips)'
                />
              }
            />
          </div> */}
          <div>
            <div id='example3' />
          </div>
          <div>
            {submitError &&
              submitError.map((error) => (
                <p className='server-errors' key={error}>
                  <strong className='red-text'>{error}</strong>
                </p>
              ))}
          </div>
          <div className='btn-wrapper'>
            <button type='submit' className='btn btn-invert'>
              <FormattedMessage
                id='create_account'
                defaultMessage='Create Account'
              />
            </button>
          </div>
        </form>
      )}
    </Form>
  )
}
